const baseUrl = '/api/'
const v1Url = `${baseUrl}v1/`
export default {
  uploadedImageDomain: process.env.VUE_APP_UPLOADED_IMAGE_DOMAIN,
  baseUrl: baseUrl,
  customerUrl: baseUrl + 'users/',
  staffUrlV1: v1Url + 'staffs',
  staffUrl: baseUrl + 'staffs/',
  updateUserProfile: baseUrl + 'users/',
  updateLineProfile: '/line_info',
  // orders
  apiGetOrderColumns: baseUrl + 'orders',
  apiPostOrder: '/orders/',
  apiGetOrder: '/orders',
  apiGetOrderDash: '/get_orders',
  apiOrderPause: '/pause',
  apiOrderStart: '/start',
  apiOrderResume: '/restart',
  apiOrderCheckout: '/checkout',
  apiOrderComplete: '/complete',
  apiGetHouseCheck: '/house_work_lists',
  apiGetTimeInfo: '/timing_info',
  apiPostTransfer: '/transfer',
  apiPostScore: '/score',
  apiUserGetOrders: '/get_orders',
  // score
  apiGetScoreOptions: '/api/order_scores/options',
  // staffs
  apiCheckStaffVaild: '/status',
  apiPostHouseWorkList: '/house_work_lists',
  apiGetStaffInfo: '/get_staff_info',
  // customer
  apiGetCustomerInfo: '/get_user_info',

  // service record
  apiGetService: 'service_records',

  apiReviewServicePage: '/review_page',
  apiCommentServicePage: '/comment_page',
  apiGetServiceRecordNoti: '/service_records/notify',
  apiServiceRecordOrderInfo: '/service_records/order_info',
  apiServiceRecordContact: '/service_records/contact',
  apiServiceRecordPreview: '/service_records/prework',
  // transfer
  apiGetTransferProfile: '/profile',
  apiGetTransferList: '/top_ups',
  apiPostTransferPlan: baseUrl + 'top_up',
  apiTransferNotify: baseUrl + 'top_up/notify',
  apiGetTransferPlan: baseUrl + 'top_up/plans',
  apiGetUnActiveTransferPlan: '/unactive_top_ups',
  // router path
  routerOrderInfo: '/orders/info',
  routerOrderList: '/orders/list',
  routerOrderScore: '/orders/score',
  routerOrderAddRecord: '/orders/addrecord',
  routerAccount: '/account/',
  routerAccountOrder: '/orderinfo',
  // action
  apiActionNew: 'new',
  apiActionEdit: 'edit',
  // debug
  apiSetLog: baseUrl + 'liff_errors/create_order'
}
